import { Locales, LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
}

const getExcelCompletionHistoryColumnOptions = ({
  language,
  messages,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  serverConfig.productCustomAttributes
    ?.filter((attr) => attr.displayInAnalytics)
    .forEach((attr) => {
      customAttributeOptions[`product.customAttributes.${attr.key}`] =
        attr.titleData?.[language || serverConfig.defaultSystemLanguage] ||
        attr.title;
    });

  return {
    'product.title': messages.commonTitle,
    'product.type': messages.commonType,
    'product.workload': `${messages.excelWorkload} (${messages.completionWorkloadHours})`,
    ...(serverConfig.workloadInDays
      ? {
          'product.workloadInDays': `${
            messages.excelWorkload
          } (${messages.commonDays.toLowerCase()})`
        }
      : {}),
    ...(serverConfig.analyticsHideProductStartDate
      ? {}
      : { 'product.startedAtDate': messages.commonStartDate }),
    'product.completionDate': messages.completionsCompletionDate,
    'product.expirationDate': messages.commonExpirationDate,
    ...customAttributeOptions,
    'product.customFields': messages.commonCustomFields
  };
};

export default getExcelCompletionHistoryColumnOptions;
